/* eslint-disable no-console, no-underscore-dangle */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import { q, featureFlag, isIE } from "@jsUtils"
import initScrollSupport from "@jsUtils/scrollSupport"

import { CONSTANTS } from "@data"

require("intersection-observer")

const { FLAGS } = CONSTANTS

export const onClientEntry = () => {
  const mode = process.env.NODE_ENV
  window._exo_ = {
    buildMode: mode,
    window: window.innerWidth
  }
  if (featureFlag("dev")) {
    console.log("Working window res: ", window._exo_.window)
    const exo = window._exo_
    window._exo_ = {
      ...exo,
      flags: FLAGS
    }
  }
  initScrollSupport()

  if (isIE()) {
    document.documentElement.classList.add("ie")
  }
}

const preRouteUpdateEvent = new CustomEvent("prerouteupdate")

export const onPreRouteUpdate = () => {
  q("body").setAttribute("class", "exo-nav-closed exo-scroll-up")
  // Event can be used to make changes before the route updates
  window.dispatchEvent(preRouteUpdateEvent)
}
export const onRouteUpdate = () => {
  document.activeElement.blur()
}
